module.exports = __webpack_public_path__ + "img/quest_visualization_total-score.d1a4bc07.svg";